// extracted by mini-css-extract-plugin
export default {"fieldContainer":"feeTemplateField_fieldContainer__x0+MX","subLabel":"feeTemplateField_subLabel__CPZit"};